import { api } from '@/redux/api/api';
import { QueryHandler } from '@/redux/types/query-handler';
import { replaceItemRecipe } from '@/redux/utils/replace-item-recipe';
import { ApplicationUser } from '@/types/application-user';
import { dispatchOptimisticPatchCreateUser } from './dispatch-optimistic-patch';
import { CreateUserQueryArg } from '../types/query-arg';

export const handleResultCreateUser: QueryHandler<
  CreateUserQueryArg,
  ApplicationUser
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch, optimisticUser } = dispatchOptimisticPatchCreateUser(
    queryArg,
    {
      dispatch,
      getState,
    },
  );

  try {
    const { data: user } = await queryFulfilled;
    dispatch(
      api.util.updateQueryData(
        'getUsers',
        undefined,
        replaceItemRecipe(
          'optimisticId' as keyof ApplicationUser,
          optimisticUser.optimisticId,
          user,
        ),
      ),
    );
  } catch (err) {
    patch.undo();
    throw err;
  }
};
